import { Box, Button, Divider, IconButton, MenuItem, MenuList, Modal, Pagination, Popover, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { Search, SearchIconWrapper, style, StyledInputBase, StyledTableCell, StyledTableRow } from "../../../styles/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { BsSearch } from "react-icons/bs";
import { toast } from "react-toastify";
import api from "../../../services/QualityAssurance";
import { useSelector } from "react-redux";
import TableLoader from "../../TableLoader";
import EditVendor from "./EditVendor";
import { Link } from "react-router-dom";

export const VendorTable = ({ refreshKey, onRefresh }) => {
    const { admToken } = useSelector((state) => state.auth);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selected, setSelected] = useState([]);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [deleting, setDeleting] = useState(false);

    const [pagination, setPagination] = useState({
        pageNumber: 1,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0
    });

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false)
    const handleCloseDeleteModal = () => setOpenDeleteModal(false);
    const handleOpenDeleteModal = () => setOpenDeleteModal(true);

    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedItem(item);
        setSelectedItemId(item.id);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleEdit = () => {
        handleClose();
        handleOpenModal();
    };

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const res = await api.getVendor(admToken);
            if (res.status && res.statusCode === 2) {
                setData(res.data)
                setPagination(prev => ({
                    ...prev,
                    totalRecords: res.totalRecord,
                    totalPages: Math.ceil(res.totalRecord / pagination.pageSize),
                    currentPage: res.currentPage || 1
                }));
                setSelected([]);
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    }, [admToken, pagination.pageSize, pagination.pageNumber]);

    useEffect(() => {
        fetchData();
    }, [admToken, pagination.pageSize, pagination.pageNumber, fetchData, refreshKey]);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
        setPagination(prev => ({ ...prev, pageNumber: 1 }));
    };

    const handlePageChange = (event, newPage) => {
        setPagination(prev => ({ ...prev, pageNumber: newPage }));
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        fetchData();
    };

    const handleDelete = useCallback(async () => {
        setDeleting(true)
        try {
            if (!selectedItemId) return;
            const res = await api.deleteVendor(admToken, selectedItemId);
            if (res.status && res.statusCode === 2) {
                toast.success(res.data.message || res.message);
                fetchData();
                handleCloseDeleteModal();
                handleClose();
            } else {
                toast.error(res.data.message || res.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setDeleting(!deleting)
        }
    }, [admToken, selectedItemId, fetchData]);

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
        <Box>
            <Box>
                <Box
                    sx={{
                        pt: 4,
                        background: "rgba(103, 30, 120, 0.1)",
                        height: "100px",
                        pl: { xs: 2.5 },
                        overflow: "hidden"
                    }}
                    onSubmit={handleSearchSubmit}
                >
                    <Search
                        sx={{
                            width: {
                                lg: "345px",
                                md: "330px",
                                sm: "auto",
                                xs: "auto",
                                pl: { xs: 6 },
                            },
                        }}
                    >
                        <SearchIconWrapper>
                            <BsSearch />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                            value={searchText}
                            onChange={handleSearchChange}
                        />
                    </Search>
                </Box>
                <TableContainer>
                    <Table
                        sx={{
                            minWidth: 700,
                            fontFamily: "Gilroy-Regular",
                            borderRadius: "0",
                        }}
                        aria-label="customized table"
                    >
                        <TableHead
                            sx={{ backgroundColor: "rgba(103, 30, 120, 0.1)", width: "100%", overflow: "hidden" }}
                        >
                            <TableRow>
                                <StyledTableCell>S/N</StyledTableCell>
                                <StyledTableCell>Company Name</StyledTableCell>
                                <StyledTableCell>Contact Person</StyledTableCell>
                                <StyledTableCell>Phone Number</StyledTableCell>
                                <StyledTableCell>Email</StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ fontFamily: "Gilroy-Regular", width: "100%" }}>
                            {loading ? (
                                <StyledTableRow>
                                    <StyledTableCell colSpan={6} align="center">
                                        <TableLoader />
                                    </StyledTableCell>
                                </StyledTableRow>
                            ) : data?.length > 0 ? (
                                data?.map((item, index) => (
                                    <StyledTableRow key={item.id || index}>
                                        <StyledTableCell component="th" scope="row">{index + 1}</StyledTableCell>
                                        <StyledTableCell>{item.companyName}</StyledTableCell>
                                        <StyledTableCell>{item.contactPersonName}</StyledTableCell>
                                        <StyledTableCell>{item.companyPhoneNumber}</StyledTableCell>
                                        <StyledTableCell>{item.companyEmail}</StyledTableCell>
                                        <StyledTableCell>
                                            <IconButton onClick={(e) => handleClick(e, item)}>
                                                <MoreVertIcon />
                                            </IconButton>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))
                            ) : (
                                <StyledTableRow>
                                    <StyledTableCell colSpan={8} align="center">
                                        No Vendor found
                                    </StyledTableCell>
                                </StyledTableRow>
                            )}
                        </TableBody>
                    </Table>
                    {pagination?.totalPages > 1 && (
                        <Box sx={{ display: "flex", justifyContent: "end", mt: 3, mb: 2 }}>
                            <Pagination
                                count={pagination.totalPages}
                                page={pagination.currentPage}
                                onChange={handlePageChange}
                                color="primary"
                                sx={{
                                    '& .MuiPaginationItem-root': {
                                        color: '#671E78',
                                    },
                                    '& .Mui-selected': {
                                        backgroundColor: 'rgba(103, 30, 120, 0.1)',
                                    },
                                }}
                                showFirstButton
                                showLastButton
                            />
                        </Box>
                    )}
                </TableContainer>
            </Box>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <Box
                    sx={{
                        bgcolor: "#671E78",
                        color: "#fff",
                        fontFamily: "Gilroy-Regular",
                        px: 3,
                    }}
                >
                    <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
                        <MenuItem
                            onClick={() => {
                                handleEdit()
                            }}
                        >
                            Edit
                        </MenuItem>
                        <Link to={`/qualityassurance/inventory/view/${selectedItem?.id}`}>
                            <MenuItem>
                                View
                            </MenuItem>
                        </Link>
                        <MenuItem
                            onClick={() => {
                                if (selectedItem) {
                                    handleClose();
                                    handleOpenDeleteModal();
                                }
                            }}
                        >
                            Delete
                        </MenuItem>
                    </MenuList>
                </Box>
            </Popover>
            {/* Edit */}
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box align="right" sx={{}}>
                        <IconButton onClick={handleCloseModal}>
                            <HighlightOffIcon />
                        </IconButton>
                    </Box>
                    <Box>
                        <Typography
                            variant="h4"
                            sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
                        >
                            Edit Vendor
                        </Typography>
                        <Divider />
                        <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
                            <EditVendor
                                onSuccess={() => {
                                    onRefresh();
                                    handleCloseModal();
                                }}
                                selectedItem={selectedItem}
                            />
                        </Box>
                    </Box>
                </Box>
            </Modal>
            {/* Delete */}
            <Modal
                open={openDeleteModal}
                onClose={handleCloseDeleteModal}
                aria-labelledby="delete-confirmation-modal"
            >
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    borderRadius: "10px",
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography variant="h6" sx={{ fontFamily: "Gilroy-Medium", mb: 2 }}>
                        Confirm Delete
                    </Typography>
                    <Typography variant="body1" sx={{ fontFamily: "Gilroy-Regular", mb: 3 }}>
                        Are you sure you want to delete this Vendor?
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                        <Button
                            variant="outlined"
                            onClick={handleCloseDeleteModal}
                            sx={{ textTransform: 'initial', fontFamily: "Gilroy-Regular" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleDelete}
                            sx={{
                                textTransform: 'initial',
                                fontFamily: "Gilroy-Regular",
                                bgcolor: '#671E78',
                                '&:hover': { bgcolor: '#4e165a' }
                            }}
                        >
                            {deleting ? "Deleting.." : "Delete"}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};